<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-if="copyImportValue"
                v-bind="attrs"
                v-on="on"
                icon
                :color="check ? 'teal': 'red'"
                @click="copyToClipboard(displayNewValue)"
            >
                <v-icon>mdi-content-copy</v-icon>
            </v-btn>
            <v-icon
                v-else
                v-bind="attrs"
                v-on="on"
                :color="check ? 'teal': 'red'"
            >
                mdi-check-circle
            </v-icon>

        </template>
        <ul>
            <li>WIMS: {{ displayOriginalValue }}</li>
            <li>IMPORTER: {{ displayNewValue }}</li>
        </ul>
    </v-tooltip>
</template>

<script>
import {computed} from "vue";
import useSharedMethod from "@/use/SharedMethod";
import useTools from "@/use/Tools";

export default {
    name: "CompareStateTd",
    props: {
        check: Boolean,
        originalValue: [String, Number, Boolean, null, undefined],
        newValue: [String, Number, Boolean, null, undefined],
        copyImportValue: Boolean,
        translatePrefix: String
    },
    setup(props) {
        const {$i18n} = useTools();
        const {copyToClipboard} = useSharedMethod();

        const displayOriginalValue = computed(() => {
            if (props.originalValue === null || props.originalValue === undefined) {
                return '';
            }
            if (props.translatePrefix) {
                return $i18n.t(`${props.translatePrefix}${props.originalValue}`);
            }
            return String(props.originalValue);
        });

        const displayNewValue = computed(() => {
            if (props.newValue === null || props.newValue === undefined) {
                return '';
            }
            if (props.translatePrefix) {
                return $i18n.t(`${props.translatePrefix}${props.newValue}`);
            }
            return String(props.newValue);
        });

        return {
            copyToClipboard,
            displayOriginalValue,
            displayNewValue,
        }
    }
}
</script>

<style scoped>

</style>